module.exports = __webpack_public_path__ + "img/p_weizhong.b5ef1db3.png";